import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router keeps scroll position across navigations by default.
 * Reset to top when the path changes (e.g. home → offer page).
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
